<template>
    <div class="salary">
        <div class="salaryTitle">
            Salary
        </div>
        <div class="groupFieldWrapper">
            <div class="groupField_wrap">
                <field
                    margin="0 10px 0 0"
                    width="170px"
                    type="number"
                    label="Customer rate"
                    placeholder="0"
                    :setInputValue="services.salary.customer_rate"
                    is-readonly
                ></field>
                <field
                    :class-error="valid.services.salary.driver_rate.$error"
                    margin="0"
                    width="170px"
                    type="number"
                    label="Driver rate"
                    placeholder="0"
                    :setInputValue="services.salary.driver_rate"
                    @updateInput="onInput($event, 'driver_rate')"
                    is-required
                ></field>
            </div>
            <salary-contact
                :contact="services.salary.contract"
                :driverList="driverList"
                :payment_type="payment_type"
            ></salary-contact>
        </div>
    </div>
</template>

<script>
import SalaryContact
from "@/components/Maintenance/Drivers/DriversForm/SecondTab/Salary/SalaryContact/SalaryContact.vue";

export default {
	name: "Salary",
	components: {
		SalaryContact
	},
	props: {
		driverList: Array,
		services: Object,
		payment_type: Array,
		valid: Object
	},
	methods: {
		onInput({ value }, key) {
			this.$emit('updateSalaryRate', value, key);
		}
	}
};
</script>

<style scoped lang="scss">
@import "Salary";
</style>
